// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__MiekC","requiredAsterisk":"Info_requiredAsterisk__1Nc4V"};